import { FUND } from "@/lib/content";

export default function Allocations() {
  return (
    <section data-testid="allocations-section" className="relative">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <div className="text-[10px] uppercase tracking-[0.35em] text-[#00E5FF]">
              Where it goes
            </div>
            <h2 className="font-display uppercase tracking-tight text-5xl md:text-6xl mt-3 leading-[0.9]">
              Every dollar,<br /> <span className="text-[#00E5FF]">accounted for.</span>
            </h2>
          </div>
          <div className="md:col-span-8 space-y-6">
            {/* Segmented bar */}
            <div className="flex h-6 w-full overflow-hidden">
              {FUND.allocations.map((a) => (
                <div
                  key={a.label}
                  style={{ width: `${a.pct}%`, background: a.color }}
                  className="relative"
                  title={`${a.label} — ${a.pct}%`}
                />
              ))}
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-4">
              {FUND.allocations.map((a) => (
                <div
                  key={a.label}
                  data-testid={`allocation-${a.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                  className="border border-[#27272A] bg-[#18181B] p-5 flex items-center gap-4"
                >
                  <div className="h-10 w-1.5" style={{ background: a.color }} />
                  <div className="flex-1">
                    <div className="text-white font-semibold">{a.label}</div>
                    <div className="text-[11px] uppercase tracking-[0.25em] text-[#71717A] mt-1">
                      {a.pct}% of funds
                    </div>
                  </div>
                  <div className="font-display text-3xl tabular" style={{ color: a.color }}>
                    {a.pct}%
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
